import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref, onMounted, inject } from "vue";
import multiSelectFilter from "../dropdowns/multi-select-filter.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'lookup-multi-select',
  props: {
  /**
   * The selected values bound with `v-model`. This is an array of objects containing ID and description pairs.
   * @type {IDDescriptionPair[]}
   * @required
   */
  modelValue: {
    type: Array as PropType<IDDescriptionPair[]>,
    required: true,
  },
  /**
   * The source lookup table from which data is fetched. This is used to retrieve a list of items from the API.
   * @type {LookupTableSource}
   * @required
   */
  lookupSource: {
    type: Number as PropType<LookupTableSource>,
    required: true,
  },
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default: ''
   */
  title: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the inactive items are included.
   * @type {boolean}
   * @default false
   */
  includeInactiveItems: {
    type: Boolean,
    default: false,
  },
  /**
   * The width of the field, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emitted when the selected values change.
   * Used to update the `v-model` in the parent component.
   * @event update:modelValue
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const selectedValues = computed({
  get: () => props.modelValue,
  set: (value: IDDescriptionPair[]) => emit("update:modelValue", value),
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const lookupItems = ref<IDDescriptionPair[]>([]);

onMounted(async () => {
  // Call api for a list of lookup items to display
  lookupItems.value = await acquaintApiClient.httpGet<IDDescriptionPair[]>(
    `app/system/lookup/${props.lookupSource}?includeinactive=${props.includeInactiveItems}`,
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(multiSelectFilter, {
    modelValue: selectedValues.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValues).value = $event)),
    "data-source": lookupItems.value,
    title: __props.title,
    width: props.width,
    readOnly: props.readOnly
  }, null, 8, ["modelValue", "data-source", "title", "width", "readOnly"]))
}
}

})